import api from "../../../settings/api";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect } from "redux-saga/effects";

export interface Fetch {
    invoiceId: string;
    callback: (success: boolean, code?: string) => void;
}

export interface RequestInvoiceAction {
    type: string;
    payload: Fetch;
}

export default function* requestInvoice({
    payload,
}: RequestInvoiceAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        const response = yield call(api.get, `/v1/vehicle-debts/internal-payment-receipt/${payload.invoiceId}`);

        if (response?.data?.status?.codigoRetorno === 0) {
            yield call(payload.callback, true, response?.data?.data);
        } else {
            yield call(payload.callback, false, "timeout");
        }

    } catch (error) {
        yield call(payload.callback, false, "timeout");
    }
}